// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-search-result-list--empty{overflow:auto;flex:1;display:flex}.ac-search-result-list__filter{padding:1rem 2rem;display:flex;background:#F6F6F6}.ac-search-result-list__list{flex:1}.ac-search-result-list__pagination{width:100%;display:flex;justify-content:space-around}\n", ""]);
// Exports
module.exports = exports;
